"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotesContext = void 0;
var NotesContext;
(function (NotesContext) {
    NotesContext["MainInformation"] = "main_information";
    NotesContext["Goals"] = "goals";
    NotesContext["Targeting"] = "targeting";
    NotesContext["TrafficAllocation"] = "traffic_allocation";
    NotesContext["AdvancedOptions"] = "advanced_options";
    NotesContext["Reporting"] = "reporting";
    NotesContext["MvtReporting"] = "mvt_reporting";
    NotesContext["CsatReporting"] = "csat_reporting";
    NotesContext["NpsReporting"] = "nps_reporting";
    NotesContext["Qa"] = "qa";
    NotesContext["VisualEditor"] = "visual_editor";
    NotesContext["CodeEditor"] = "code_editor";
    NotesContext["LiveHitsReporting"] = "live_hits_reporting";
})(NotesContext = exports.NotesContext || (exports.NotesContext = {}));
//# sourceMappingURL=types.js.map